import angular from 'angular';

(function() {
  'use strict';

  angular.module('app.core').factory('AuthSvc', AuthSvc);

  /*
   * Gestion des autorisations. Liste des rôles de l'appli :
   * - USER
   * - ADMIN
   * - SUPPORT
   * - OPERATION
   * - ACCOUNTANT
   * - EXECUTIVE
   */

  AuthSvc.$inject = ['$http', '$state', '$q', '$window', 'logger', 'CONF', 'SessionSvc'];
  /* @ngInject */
  function AuthSvc($http, $state, $q, $window, logger, CONF, SessionSvc) {
    var redirectToStateAfterLogin = { state: 'app.home', params: null };

    var exports = {
      login: login,
      relogin: relogin,
      logout: logout,
      isAuthenticated: isAuthenticated,
      isAuthorized: isAuthorized,
      saveAttemptState: saveAttemptState,
      redirectToAttemptedState: redirectToAttemptedState,
      ping: ping,
      isEditAuthorized: isEditAuthorized
    };

    return exports;

    ////////////////

    function login(username, pwd) {
      var headers = { authorization: 'Basic ' + utf8_to_b64(username + ':' + pwd) };
      return $http
        .get(CONF.apiContext + CONF.apiBoBaseUrl + '/v1/users/whoAmI', {
          headers: headers
        })
        .then(_createSession);
    }

    function utf8_to_b64(str) {
      return window.btoa(unescape(encodeURIComponent(str)));
    }

    function relogin() {
      return $http.get(CONF.apiContext + CONF.apiBoBaseUrl + '/v1/users/whoAmI').then(_createSession, function(reason) {
        $q.reject(reason);
      });
    }

    function logout() {
      return $http.post(CONF.apiContext + CONF.apiBoBaseUrl + '/logout').finally(function() {
        _clearSession();
      });
    }

    function _createSession(res) {
      var user = res.data;
      // Vérifie que la réponse contient bien un utilisateur
      // (cas du redirect vers la page de login lors de l'appel du whoAmI)
      if (!user.login) {
        return null;
      }

      return SessionSvc.create(user);
    }

    function _clearSession() {
      SessionSvc.destroy();
      $state.go('app.login');
      return;
    }

    function isAuthenticated() {
      return !!SessionSvc.getCurrentUser();
    }

    function isAuthorized(authorizedRole) {
      return isAuthenticated() && SessionSvc.getCurrentUser().roles.indexOf(authorizedRole) !== -1;
    }

    function saveAttemptState(attemptState) {
      var attemptStateName = attemptState.name();
      if (attemptStateName !== 'app.login' && attemptStateName !== '') {
        redirectToStateAfterLogin = { state: attemptStateName, params: attemptState.params() };
      } else {
        redirectToStateAfterLogin = { state: 'app.home' };
      }
    }

    function redirectToAttemptedState() {
      $state.go(redirectToStateAfterLogin.state, redirectToStateAfterLogin.params);
    }

    function ping() {
      return $http.get(CONF.apiContext + CONF.apiBoBaseUrl + '/v1/users/whoAmI');
    }

    function isEditAuthorized() {
      return isAuthorized('CONFIGURATOR');
    }
  }
})();
